export const startupsPage = {
  seo: {
    title: "80% Off Shariah Compliance API for Startups | Akinda",
    description:
      "Akinda helps startups with 80% off the Shariah compliance API. Apply with your company info and startup description — email contact@akinda.io.",
    keywords:
      "startup api discount, halal stock api startups, shariah compliance api, islamic finance api startup, akinda startups",
    ogTitle: "80% Off Shariah Compliance API for Startups | Akinda",
    ogDescription:
      "Eligible startups get 80% off Akinda AAOIFI-aligned Shariah compliance API. Apply via contact@akinda.io.",
  },
  hero: {
    badge: "For startups",
    title:
      "{{percent}}% off Shariah compliance API for startups",
    lead: "Akinda helps early-stage teams ship AAOIFI-aligned stock screening without enterprise pricing. Apply with your company details and a short description — email {{email}}.",
    ctaApply: "Apply for the discount",
    ctaDocs: "Read API docs",
    offerAria: "Startup offer",
    offerChip: "Startup offer",
    offerUpto: "upto",
    offerValuation: "valuation",
    offerEligibility: "For preseed & seed startups",
    offerNote:
      "Same production endpoints and screening quality — discounted for early-stage teams.",
  },
  benefits: {
    label: "Why apply",
    title: "Screen equities. Ship faster.",
    lead: "Get the same Shariah compliance data banks and fintechs use — at a price that fits early runway.",
    discount: {
      title: "80% off API pricing",
      description:
        "Preseed and seed startups valued under $5M get eighty percent off Akinda’s Shariah compliance API — same endpoints, same AAOIFI-aligned data.",
    },
    api: {
      title: "Production-ready screening",
      description:
        "Compliance verdicts, AAOIFI ratios, full reports, and purification amounts via REST — ready to embed in your product.",
    },
    support: {
      title: "Built for early teams",
      description:
        "Ship a halal investing feature without building screening infrastructure from scratch.",
    },
  },
  apply: {
    label: "How to apply",
    title: "Three steps to submit",
    lead: "Write a description of your startup, add company info, and send it to {{email}}.",
    steps: {
      describe: {
        title: "Describe your startup",
        description: "Tell us what you’re building and how you’ll use the API.",
      },
      company: {
        title: "Share company info",
        description: "Company name, website, and a contact we can reply to.",
      },
      email: {
        title: "Email {{email}}",
        description:
          "Submit the form — we’ll open an email to our team with your details ready to send.",
      },
    },
    formTitle: "Startup application",
    formLead:
      "Submitting opens your email client with a message to {{email}}. Review and send to complete your request.",
    sectionCompany: "Company",
    sectionContact: "Contact",
    sectionDescription: "Description",
    companyName: "Company name",
    website: "Website",
    optional: "(optional)",
    contactName: "Contact name",
    contactEmail: "Contact email",
    description: "Startup description",
    descriptionPlaceholder:
      "What are you building, who is it for, and how will you use Akinda’s Shariah compliance API?",
    submit: "Email application",
    orWrite: "Or write us directly at",
    errors: {
      companyName: "Please enter your company name.",
      contactName: "Please enter a contact name.",
      contactEmail: "Please enter a valid contact email.",
      description:
        "Please write a short description of your startup (at least a few sentences).",
    },
  },
  note: {
    ariaLabel: "Eligibility note",
    body: "For preseed and seed startups with valuation lower than $5M. Eligibility is reviewed case by case. We’ll reply to the contact email you provide. Questions?",
  },
  mailto: {
    subject: "Startup API discount request — {{company}}",
    greeting: "Hi Akinda team,",
    intro:
      "I'd like to apply for the 80% Shariah compliance API discount for preseed/seed startups (valuation under $5M).",
    company: "Company",
    website: "Website",
    contactName: "Contact name",
    contactEmail: "Contact email",
    description: "Startup description:",
    thanks: "Thanks,",
    emptyWebsite: "—",
  },
} as const;
